import { useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from 'hooks';
import { Button, Logo, NavBar } from 'legacy-components/componets';
import ProfileSection from './profile-section/ProfileSection';
import { PenaltyPaymentAlert } from 'components/organisms/Alert/PenaltyPaymentAlert';

const Header = () => {
  const { isAuthenticated } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const isPenaltyCheckout = location.pathname.startsWith('/penalty-payment/');
  const isPenaltiesPage = location.pathname.includes('/penalties');

  const handleAuthNavigateClick = () => {
    navigate('/auth/sign-in');
  };

  return (
    <>
      <nav
        className='bg-white'
        style={{
          boxShadow: '0px 4px 36px 4px #97979714',
        }}
      >
        <div className='px-7 md:px-28 md:border-b-0 border-b border-b-[#EFF7FB]'>
          <div className='relative flex h-[74px] items-center justify-between'>
            <Logo />
            <NavBar isAuthenticated={isAuthenticated} />
            {isAuthenticated ? (
              <ProfileSection />
            ) : (
              <Button label={'Sign in'} onClick={handleAuthNavigateClick} theme={'default'} />
            )}
          </div>
        </div>
      </nav>
      {isAuthenticated && !isPenaltyCheckout && !isPenaltiesPage && (
        <div className='px-7 md:px-28'>
          <PenaltyPaymentAlert />
        </div>
      )}
    </>
  );
};

export { Header };
